<template>
  <section>
    <div class="container">
      <div v-if="fill_info == '' && subpage == 'data'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló</div>
        </div>

        <div class="col-sm-6">
          <inputbox id="nev" label="Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="mobilszam" label="Mobilszám" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" name="mobilszam" v-model="form.mobilszam" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox :disabled="true" id="neptunkod" label="Neptunkód" name="neptunkod" v-model="form.neptunkod" :errors="errors"/>
        </div>

        <div class="col-xs-12">
          <div class="info-box download" style="margin: 20px 0px;">
            <a target="_blank" :href="'assets/files/ekop_kdp_'+felev_kod+'_sablon.docx'" title="Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló sablon letöltés">
              <span class="highlight">Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló sablon</span> letöltés
            </a>
          </div>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_beszamolo_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="szakmai_beszamolo_szerkesztheto" label="Szakmai beszámoló szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 3000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Szakmai Beszámoló_szerk. legyen.)</span>" name="szakmai_beszamolo_szerkesztheto" :loaded_files="form.szakmai_beszamolo_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_beszamolo = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szakmai_beszamolo" label="Szakmai beszámoló aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 3000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Szakmai Beszámoló legyen.)</span>" name="szakmai_beszamolo" :loaded_files="form.szakmai_beszamolo"/>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.fogado_doktori_iskola_ertekelese_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="fogado_doktori_iskola_ertekelese_szerkesztheto" label="Fogadó doktori iskola értékelése szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Fogadó Doktori Iskola Értékelés_szerk. legyen.)</span>" name="fogado_doktori_iskola_ertekelese_szerkesztheto" :loaded_files="form.fogado_doktori_iskola_ertekelese_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.fogado_doktori_iskola_ertekelese = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="fogado_doktori_iskola_ertekelese" label="Fogadó doktori iskola értékelése aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Fogadó Doktori Iskola Értékelés legyen.)</span>" name="fogado_doktori_iskola_ertekelese" :loaded_files="form.fogado_doktori_iskola_ertekelese"/>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_ertekeles_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="temavezetoi_ertekeles_szerkesztheto" label="Témavezetői értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Témavezetői Értékelés_szerk. legyen.)</span>" name="temavezetoi_ertekeles_szerkesztheto" :loaded_files="form.temavezetoi_ertekeles_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_ertekeles = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="temavezetoi_ertekeles" label="Témavezetői értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Témavezetői Értékelés legyen.)</span>" name="temavezetoi_ertekeles" :loaded_files="form.temavezetoi_ertekeles"/>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.vallalati_szakerto_ertekelese_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="vallalati_szakerto_ertekelese_szerkesztheto" label="Vállalati szakértő értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Vállalati Szakértő Értékelés_szerk. legyen.)</span>" name="vallalati_szakerto_ertekelese_szerkesztheto" :loaded_files="form.vallalati_szakerto_ertekelese_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.vallalati_szakerto_ertekelese = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="vallalati_szakerto_ertekelese" label="Vállalati szakértő értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(Legalább 2000 karakter szükséges. A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Vállalati Szakértő Értékelés legyen.)</span>" name="vallalati_szakerto_ertekelese" :loaded_files="form.vallalati_szakerto_ertekelese"/>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.konzultacios_lap = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="konzultacios_lap" label="Konzultációs lap aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Konzultációs lap legyen.)</span>" name="konzultacios_lap" :loaded_files="form.konzultacios_lap"/>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.publikacios_es_szabadalmi_teljesitmeny = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="publikacios_es_szabadalmi_teljesitmeny" label="Publikációs és szabadalmi teljesítmény bemutatása aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP-KDP Publikációs És Szabadalmi Teljesítmény Bemutatása legyen.)</span>" name="publikacios_es_szabadalmi_teljesitmeny" :loaded_files="form.publikacios_es_szabadalmi_teljesitmeny"/>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(1)" :disabled="saving" type="button" class="button">Mentés</button>
            <button v-on:click="save(2)" :disabled="saving" type="button" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">Egyetemi Kutatói Ösztöndíj Program Kooperatív Doktori Program szakmai beszámoló</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    felev_kod: {
      type: String,
      required: true
    }
  },

  data: function() {
    return {
      saving: false,
      errors: [],
      fill_info: '',
      subpage: 'data',
      form: {
        nev: '',
        email: '',
        mobilszam: '',
        neptunkod: '',
        szakmai_beszamolo_szerkesztheto: [],
        szakmai_beszamolo: [],
        fogado_doktori_iskola_ertekelese_szerkesztheto: [],
        fogado_doktori_iskola_ertekelese: [],
        temavezetoi_ertekeles_szerkesztheto: [],
        temavezetoi_ertekeles: [],
        vallalati_szakerto_ertekelese_szerkesztheto: [],
        vallalati_szakerto_ertekelese: [],
        konzultacios_lap: [],
        publikacios_es_szabadalmi_teljesitmeny: []
      }
    }
  },

  mounted: function() {
    var _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/ekop_kdp_beszamolo_init', {
      data: {
        felev_kod: this.felev_kod
      },
      method: 'POST',
      success: function(response) {
        if (response.error != false) {
          _this.fill_info = response.error;
          return;
        }

        if (response.form != undefined) {
          _this.form = Object.assign({}, _this.form, response.form);
        }
      }
    });
  },

  methods: {
    save: function(veglegesit) {
      var _this = this;

      this.saving = true;
      this.errors = [];

      this.$root.ajax('form/ekop_kdp_beszamolo_ment', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          felev_kod: this.felev_kod,
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.saving = false;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 1 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// ekop_kdp_szakmai_beszamolo.vue?619cc68a